export default {
  admin: () => import("/var/www/layouts/admin.vue").then(m => m.default || m),
  "agent-refactor": () => import("/var/www/layouts/agent-refactor.vue").then(m => m.default || m),
  agent: () => import("/var/www/layouts/agent.vue").then(m => m.default || m),
  dark: () => import("/var/www/layouts/dark.vue").then(m => m.default || m),
  "dark-no-footer": () => import("/var/www/layouts/darkNoFooter.vue").then(m => m.default || m),
  default: () => import("/var/www/layouts/default.vue").then(m => m.default || m),
  inactive: () => import("/var/www/layouts/inactive.vue").then(m => m.default || m),
  "reservation-admin-full": () => import("/var/www/layouts/reservation-admin-full.vue").then(m => m.default || m),
  "reservation-admin-print": () => import("/var/www/layouts/reservation-admin-print.vue").then(m => m.default || m),
  "reservation-admin": () => import("/var/www/layouts/reservation-admin.vue").then(m => m.default || m),
  reservation: () => import("/var/www/layouts/reservation.vue").then(m => m.default || m),
  user: () => import("/var/www/layouts/user.vue").then(m => m.default || m)
}